import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import Cookies from "js-cookie";

import {
  API_MENU_CHAPTERS_ALL,
  API_CHAPTERS_BY_ROLE,
  MAIN_URL,
  PORT_FOR_AUTH,
  API_MENU_ACTIONS_ALL,
  API_CHAPTER_SAVE,
  API_AVAILABLE_ACTIONS_BY_CHAPTER_ID,
  API_ACTION_SAVE,
  API_ACTIONS_BY_CHAPTER_ID,
  API_AVAILABLE_CHAPTERS_BY_CHAPTER_ID,
} from "../../constants/constants";

import {
  GET_ACTION_BY_CHAPTER_PRIV_ID,
  GET_AVAILABLE_ACTION_BY_CHAPTER_PRIV_ID,
  GET_CHAPTERS_BY_ROLE,
  GET_CHAPTERS_BY_USER_ID,
  GET_MENU_ACTIONS_ALL,
  GET_MENU_CHAPTERS_ALL,
} from "../types";

export const menuChaptersAll = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_MENU_CHAPTERS_ALL,
    );

    const data = await response.json();

    dispatch({
      type: GET_MENU_CHAPTERS_ALL,
      data: data,
    });
  };
};

export const menuChapter = (roleId) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_CHAPTERS_BY_ROLE + roleId,
    );

    const data = await response.json();

    dispatch({
      type: GET_CHAPTERS_BY_ROLE,
      data: data,
    });
  };
};

export const availableChaptersByUseId = (userId) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_AVAILABLE_CHAPTERS_BY_CHAPTER_ID + userId,
    );

    const data = await response.json();

    dispatch({
      type: GET_CHAPTERS_BY_USER_ID,
      data: data,
    });
  };
};

export const saveChapter = (chapter) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_CHAPTER_SAVE,
      {
        method: "POST",
        body: JSON.stringify(chapter),
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.ok) {
      dispatch(menuChapter(chapter.roleid));
    }

    const userId = Cookies.get("userId");

    dispatch(availableChaptersByUseId(userId));
  };
};

export const menuActionsAll = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_MENU_ACTIONS_ALL,
    );

    const data = await response.json();

    dispatch({
      type: GET_MENU_ACTIONS_ALL,
      data: data,
    });
  };
};

export const getActionByChapterId = (chapterId) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_ACTIONS_BY_CHAPTER_ID + chapterId,
    );

    const data = await response.json();

    dispatch({
      type: GET_ACTION_BY_CHAPTER_PRIV_ID,
      data: data,
    });
  };
};

export const availableActionByChapterId = (chapterId) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL +
        PORT_FOR_AUTH +
        API_AVAILABLE_ACTIONS_BY_CHAPTER_ID +
        chapterId,
    );

    const data = await response.json();

    dispatch({
      type: GET_AVAILABLE_ACTION_BY_CHAPTER_PRIV_ID,
      data: data,
    });
  };
};

export const saveAction = (action) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_AUTH + API_ACTION_SAVE,
      {
        method: "POST",
        body: JSON.stringify(action),
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response.ok) {
      dispatch(availableActionByChapterId(action.chapterPrivId));
    }
  };
};
